module.exports = __webpack_public_path__ + "img/stock2.94355a65.png";